import React from 'react';

import { ChevronDownIcon } from '@adsk/alloy-react-icon';
import { useTheme } from '@adsk/alloy-react-styles';
import { StylableComponent } from '@adsk/alloy-react-theme';

type ToggleButtonProps = StylableComponent<HTMLDivElement> & {
  isOpen: boolean;
  disabled?: boolean;
};

const ToggleIcon = ({ style, isOpen, ...props }: ToggleButtonProps) => {
  const theme = useTheme();
  const t = theme.tokens?.component?.datePicker;
  return (
    <div
      data-testid={'DatePicker__toggle'}
      style={{
        display: 'flex',
        padding: 0,
        cursor: props.disabled ? 'not-allowed' : undefined,
        marginLeft: 'auto',
      }}
      {...props}
    >
      <ChevronDownIcon
        style={[
          {
            ...t?.toggleIcon?._,
            ...(isOpen
              ? t?.toggleIcon?.open?.true
              : t?.toggleIcon?.open?.false),
          },
          style,
        ]}
      />
    </div>
  );
};

export default ToggleIcon;
